import { DEFAULT_CURRENCY } from '../const';

const getShopCurrency = (shop) => {
  return shop?.currency || shop?.config?.currency || DEFAULT_CURRENCY;
};

const ShopHelper = {
  getShopCurrency,
};

export default ShopHelper;
